import {AppEpics} from "./app/epics";
import {AuthEpics} from "./auth/auth.epics";
import {PaymentFormEpics} from "./payment-form/payment-form.epics";
import {PaymentsEpics} from "./payments/payments.epics";
import {combineEpics} from "redux-observable";

export default combineEpics(AppEpics, PaymentsEpics, PaymentFormEpics, AuthEpics);
